import {Pipe, PipeTransform, SecurityContext} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true
})
export class SafeHtmlPipe implements PipeTransform {

  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): string {
    if (!value) {
      return '';
    }
    // Sanitize the HTML to remove any dangerous content while keeping safe HTML like <a> tags
    return this.sanitizer.sanitize(SecurityContext.HTML, value) || '';
  }
}


